import SyncableModel from './SyncableModel';
import Farm from './Farm';
import { getRootStore } from "../utils/root-store"
import Product from "./Product"
import _ from "lodash"
import Expression from "react-native-jala-orm/src/query/Expression"

export default class Stock extends SyncableModel {
    static name = 'Stock'

    _fillable = [
      'id', 'farm_id', 'product_id', 'created_by', 'updated_by',
      'created_at', 'updated_at', 'low_limit', 'lowest_limit',
      'archive', 'synced_at', 'deleted_at',
    ]

    _casts = {
      archive: 'bool',
      low_limit: 'float',
      lowest_limit: 'float'
    };

    static _parents = ['farm'];

    static endpoint = '/stocks'

    static syncOnly = true

    static searchables = ['product_name']

    static _boot() {
      super._boot();

      this.addGlobalScope('global', (query: Builder) => {
        if (_.isEmpty(query.getQuery().columns)) {
          query.select([query.qualifyColumn('*')]);
        }

        const product = (new Product()).setTable(`${query.getModel().getTable()}_products`);
        query.leftJoin(
          `${(new Product()).getTable()} as ${product.getTable()}`,
          product.getQualifiedKeyName(), query.qualifyColumn(product.getForeignKey())
        );
      });
    }

    qualifyColumn(column: string): string {
      if (column === '*') {
        return new Expression([
          `${this.getTable()}.*`,
          `${this.qualifyColumn('product_name')} as product_name`,
          `${this.qualifyColumn('product_unit')} as product_unit`,
          `${this.qualifyColumn('product_category_id')} as product_category_id`,
        ].join(', '));
      }
      if (['product_name', 'product_unit'].includes(column)) {
        const product = (new Product()).setTable(`${this.getTable()}_products`);
        return product.qualifyColumn(column.replace('product_', ''))
      }
      if (column === 'product_category_id') {
        const product = (new Product()).setTable(`${this.getTable()}_products`);
        return product.qualifyColumn(column);
      }
      return super.qualifyColumn(column);
    }

    relationFarm() {
      return Farm.query().withoutGlobalScope('soft_delete').whereKey(this.farm_id);
    }

    static async syncAll(
      params = {}, sqlParams = [], cleanAfterSync = true,
      onSyncProgressUpdate = undefined, onError = undefined
    ) {
      const { userStore: { user } } = getRootStore();
      const _params = { ...params };
      const _sqlParams = [...sqlParams];
      if (user && user.role_id === 1 && !_params.farm_id__in) {
        _params.has = 'farm.farm_user';
      }
      return super.syncAll(_params, _sqlParams, cleanAfterSync, onSyncProgressUpdate, onError);
    }
}
